// menu.component.ts
import { Component, Input, signal } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

export interface MenuItem {
    icon: string;
    label: string;
    route?: string;
    subItems?: MenuItem[];
}

@Component({
    selector: 'sura-menu',
    templateUrl: './menu.component.html',
    standalone: false
})
export class MenuComponent {

    private readonly programadorUrl = `${environment.programadorBaseUrl}`;

    constructor(private readonly router: Router) {
        this.initializeMenu();
    }

    sideNavCollapsed = signal(false);

    @Input() set collapsed(val: boolean) {
        this.sideNavCollapsed.set(val);
    }

    menuItems = signal<MenuItem[]>([]);

    private initializeMenu(): void {
        const allMenuItems: MenuItem[] = [
          {
            icon: "home",
            label: "Inicio",
            route: "",
          },
          {
            icon: "edit",
            label: "Remision",
            route: "remision",
            subItems: [
              {
                icon: "",
                label: "Crear",
                route: "nueva",
              },
              {
                icon: "",
                label: "Lista Remisiones",
                route: "listar-remisiones",
              },
              {
                icon: "",
                label: "Fur Remisiones",
                route: "migrar-remision",
              },
            ],
          },
          {
            icon: "autorenew",
            label: "Plan de Manejo",
            route: "novedad",
            subItems: [
              {
                icon: "",
                label: "Crear Novedades",
                route: "nueva",
              },
              {
                icon: "",
                label: "Gestionar Novedades",
                route: "gestionar-novedades",
              },
              {
                icon: "",
                label: "Gestionar Pacientes",
                route: "gestionar-pacientes",
              },
              {
                icon: "",
                label: "Historial",
                route: "historial-plan-manejo",
              },
            ],
          },
          {
            icon: "assignment",
            label: "Solicitud",
            route: "solicitud",
            subItems: [
              {
                icon: "",
                label: "Crear",
                route: "nueva",
              },
              {
                icon: "",
                label: "Lista Solicitudes",
                route: "listar-solicitudes",
              },
            ],
          },
          {
            icon: "credit_card",
            label: "Recaudo",
            route: "recaudo",
          },
          {
            icon: "date_range",
            label: "Linea Unica",
            route: "lineaunica",
            subItems: [
              {
                icon: "",
                label: "Lista",
                route: "lista-linea-unica",
              },
              {
                icon: "",
                label: "Citas",
                route: "citas",
              },
            ],
          },
          {
            icon: "vaccines",
            label: "Equipos Biomedicos",
            route: "equiposbiomedicos",
            subItems: [
              {
                icon: "",
                label: "Historial Gestion",
                route: "historial-gestion",
              },
              {
                icon: "",
                label: "Gestion Acceso",
                route: "gestion-acceso",
              },
            ],
          },
          {
            icon: "insert_chart",
            label: "Informes",
            route: "informes",
            subItems: [
              {
                icon: "",
                label: "Hospitalarios",
                route: "crear-informes",
              },
              {
                icon: "",
                label: "No hospitalarios",
                route: "no-hospitalarios",
              },
            ],
          },
          {
            icon: "open_in_new",
            label: "Programador",
            route: `${this.programadorUrl}`,
          },
        ];
        this.menuItems.set(allMenuItems);
    }

}
